export const LOAD_CAMPAIGN = 'Dyzio/Campaign/LOAD_CAMPAIGN';
export const LOADING_CAMPAIGN = 'Dyzio/Campaign/LOADING_CAMPAIGN';
export const LOAD_CAMPAIGN_SUCCESS = 'Dyzio/Campaign/LOAD_CAMPAIGN_SUCCESS';
export const LOAD_CAMPAIGN_ERROR = 'Dyzio/Campaign/LOAD_CAMPAIGN_ERROR';

export const SET_MY_PERMISSION_INFO = 'Dyzio/Campaign/SET_MY_PERMISSION_INFO';



/** WEBPACK FOOTER **
 ** ./src/containers/campaign/constants.js
 **/